<template>    
      <select class="w3-select" v-model="fieldModelValue">
        <option disabled value="">Please select ...</option>
        <option v-for="(user,index) in groupusers"  :value="constructfulluser(index,user)" :key="index">{{user.knownAs}}</option>           
     </select>
</template>


<script>
    import {
    mapGetters,
    mapActions
  } from "vuex";


  export default {    
    props: ["business"],    
    data: function() {
      return {        
        groupusers:null
      }
    },
    computed: {       
      fieldModelValue: {
            get() {
              return this.value;
            },
            set(newValue) {
              this.$emit('input', newValue);
            }
      }     
    },
    methods: {  
      constructfulluser(index,user){
          let installer = {
            id:index,
            knownAs:user.knownAs
          }
          
          return installer
      },            
      getUsers(){
          
           this.getbusinessgroupusers({business:this.business}).then((groupusers)=>{ 
              // let installers = Object.keys(groupusers).reduce((accum,key)=>{
              //     let gu = groupusers[key]
              //     if(gu.installer)
              //         accum[key] = {knownAs:gu.knownAs}
              //     return accum
              // },{})                                        
              this.groupusers = groupusers
            })
          
      },
      ...mapActions(['getbusinessgroupusers'])   
    },
    created(){
        this.getUsers();
    }
  };
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/Installers.vue